import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { useSelectedNode } from "./useSelectedNode";
export var useListOfSelectedNodes = function useListOfSelectedNodes() {
  var _useSelectedNode = useSelectedNode(),
    level1Node = _useSelectedNode.level1Node,
    level2Node = _useSelectedNode.level2Node,
    level3Node = _useSelectedNode.level3Node,
    level4Node = _useSelectedNode.level4Node,
    level5Node = _useSelectedNode.level5Node;
  var nodes = [level1Node, level2Node, level3Node, level4Node, level5Node];
  var selectedNodes = nodes.filter(isNotUndefined);
  return {
    selectedNodes: selectedNodes
  };
};